import IconButton from '@mui/material/IconButton';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { formatProviderName } from '../../helpers/providers';
import { formatDate } from '../../helpers/dates';
import EditLeadButton from './EditLeadButton';

const LeadTableRow = props => {
  const {data} = props.row;
  return (
    <>
      <TableRow key={data.id}>
        <TableCell align="left">{formatDate(data.date_created)}</TableCell>
        <TableCell align="left">{data.status}</TableCell>
        <TableCell align="left">{data.contact_first_name} {data.contact_last_name}</TableCell>
        <TableCell align="left">{data.contact_email}</TableCell>
        <TableCell align="left">{data.contact_phone}</TableCell>
        <TableCell align='left'>
          {
            data?.provider
            ? formatProviderName(data.provider)
            : 'Unassigned'
          }
        </TableCell>
        <TableCell>
          <EditLeadButton 
            iconOnly={true}
            lead={data}
            size='small'
            afterEdit={props.afterEdit || null}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default LeadTableRow;